import * as React from "react";
import { Link } from "react-router-dom";
import C from "classnames";
export const NavLink = (props) => {
    const [toggled, setToggled] = React.useState(false);
    const onClick = () => {
        setToggled((d) => !d);
        props.onClick && props.onClick();
    };
    return props.to ? (React.createElement(Link, { className: C("nav-link", props.active && "active", props.dropdown ? "dropdown " + (toggled ? "expanded" : "collapsed") : ""), to: props.to, onClick: onClick, "data-testid": props.testId }, props.children)) : (React.createElement("a", { className: C("nav-link", props.active && "active", props.dropdown ? "dropdown " + (toggled ? "expanded" : "collapsed") : ""), href: props.href, onClick: onClick, "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=NavLink.js.map